import React, { useRef, useState } from 'react';
import parse from 'html-react-parser';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import { PrimaryButton } from 'common/TailwindComponents';
import DialogV2 from 'common/modal/DialogV2';
import { ENROLLMENT_STATUSES, REQUEST_TYPES } from '../constants';
import { useAcceptEnrollmentRequest } from '../hooks';
import { isSelectedInBulkActions } from '../utils/isSelectedInBulkActions';

const AcceptEnrollmentRequestButton = ({
  deselectEnrollment,
  enrollmentRequest,
  fullViewPage,
  setDrawerOpen,
  selectedEnrollments,
}) => {
  const isEnrollType = enrollmentRequest.request_type === REQUEST_TYPES.enroll;
  const isOpenStatus = enrollmentRequest.enrollment_status === ENROLLMENT_STATUSES.open;
  const isReviewStatus = enrollmentRequest.enrollment_status === ENROLLMENT_STATUSES.inReview;
  const disableAcceptButton = !(isOpenStatus || isReviewStatus);

  const acceptModalRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const acceptEnrollmentRequest = useAcceptEnrollmentRequest();

  const closeAcceptEnrollmentModal = () => {
    // eslint-disable-next-line no-unused-expressions
    acceptModalRef.current?.closeDialog();
  };

  const openAcceptEnrollmentModal = () => {
    acceptModalRef.current.openDialog();
  };

  const acceptEnrollment = async () => {
    setIsSubmitting(true);
    try {
      await acceptEnrollmentRequest(enrollmentRequest);
      if (!fullViewPage) setDrawerOpen(false);

      if (isSelectedInBulkActions(selectedEnrollments, enrollmentRequest.id)) {
        deselectEnrollment([enrollmentRequest]);
      }
    } finally {
      setIsSubmitting(false);
      closeAcceptEnrollmentModal();
    }
  };

  return (
    <>
      <PrimaryButton
        disabled={disableAcceptButton}
        label="Accept"
        ariaLabel="accept enrollment request"
        onClick={openAcceptEnrollmentModal}
        primary
        icon="CheckCircle"
      />
      <DialogV2
        ref={acceptModalRef}
        title={isEnrollType ? (`Confirm Enrollment Request #${enrollmentRequest.short_id}`) :
          (`Confirm Disenrollment Request #${enrollmentRequest.short_id}`)}
        confirmLabel="Confirm"
        confirmationBtnDisabled={isSubmitting}
        cancelHandler={closeAcceptEnrollmentModal}
        confirmationHandler={acceptEnrollment}
      >
        <p className="pb-4">
          Accepting this request will {isEnrollType ? parse('<b>enroll</b> the client to ') :
            parse('<b>disenroll</b> the client from ')}
          <b>{get(enrollmentRequest, 'plan.name')}</b>.
        </p>
        <p>&nbsp;</p>
      </DialogV2>
    </>
  );
};

AcceptEnrollmentRequestButton.propTypes = {
  deselectEnrollment: PropTypes.func,
  enrollmentRequest: PropTypes.object.isRequired,
  fullViewPage: PropTypes.bool,
  setDrawerOpen: PropTypes.func,
  selectedEnrollments: PropTypes.array,
};

AcceptEnrollmentRequestButton.defaultProps = {
  deselectEnrollment: () => {},
  fullViewPage: false,
  setDrawerOpen: () => {},
  selectedEnrollments: [],
};

export default AcceptEnrollmentRequestButton;
